import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';
import { CategoryArticleList, CategoryArticleSkeleton, HelpContainer } from '@swf/help';

import { helpCenterCategoryWidgetModel, useHelpCenterCategoryWidget } from './model';

const HelpCenterCategoryWidget: WidgetFC = () => {
  const { widgetSelect } = useHelpCenterCategoryWidget();
  const categoriesList = useSelector(widgetSelect.categoriesList);
  const categoryArticles = useSelector(widgetSelect.categoryArticles);
  const categoryArticlesMeta = useSelector(widgetSelect.categoryArticlesMeta);
  const pageSize = useSelector(widgetSelect.pageSize);
  const urlParams = useSelector(select.cms.getUrlParams);

  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const isLoading = useSelector(widgetSelect.isLoading);

  return (
    <HelpContainer
      isLoading={isLoading}
      isPreloaded={hasPreloaded}
      preloader={<CategoryArticleSkeleton />}
    >
      <CategoryArticleList
        categories={categoriesList}
        categoryArticles={categoryArticles}
        categoryArticlesMeta={categoryArticlesMeta}
        pageSize={pageSize}
        categoryId={urlParams.category}
      />
    </HelpContainer>
  );
};

HelpCenterCategoryWidget.model = helpCenterCategoryWidgetModel;

export default HelpCenterCategoryWidget;
